// File: src/miniapps/lex-loginsignup-popup/lex-loginsignup-popup.js

import React, { useState } from 'react';
import { useAuth } from '../../user/AuthContext';

import './lex-loginsignup-popup.css';

export default function LexLoginSignupPopup({ loginPromptVisible, setLoginPromptVisible }) {
  const { user, loginWithGoogle, login, signup } = useAuth();

  const [isSignupMode, setIsSignupMode] = useState(false);
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!loginPromptVisible || user) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = form;
    if (!email || !password || password.length < 6) {
      setError('Email and password are required (min 6 characters).');
      return;
    }

    setLoading(true);
    try {
      if (isSignupMode) {
        await signup({ email, password });
      } else {
        await login(email, password);
      }
      // Close the popup but stay on the current page
      setLoginPromptVisible(false);
    } catch (err) {
      setError(err.message || 'Auth failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setLoading(true);
    try {
      await loginWithGoogle();
      // Close the popup but stay on the current page
      setLoginPromptVisible(false);
    } catch (err) {
      setError(err.message || 'Google auth failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lex-popup-overlay">
      <div className="lex-popup-border">
        <div className="lex-popup-prompt">
          <p>Login to Explore Millions of <br /> Mini AI Apps</p>

          {error && <div className="lex-popup-error">{error}</div>}

          <form className="lex-popup-form" onSubmit={handleEmailSubmit}>
            <input
              name="email"
              type="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <div className="lex-popup-password-field">
              <input
                name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="lex-popup-toggle-password"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </form>

          <div className="lex-popup-buttons">
            <button type="submit" onClick={handleEmailSubmit} disabled={loading}>
              {loading ? 'Processing…' : isSignupMode ? 'Sign Up' : 'Login'}
            </button>
            <button type="button" onClick={() => setIsSignupMode((prev) => !prev)}>
              {isSignupMode ? 'Or Login' : 'Or Sign Up'}
            </button>
            <button onClick={handleGoogle} disabled={loading}>
              {loading ? 'Authenticating…' : 'Continue with Google'}
            </button>
            <button onClick={() => setLoginPromptVisible(false)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
